.divider {
  flex: none;
  background: var(--color-border);
}

.vertical {
  align-self: stretch;
  width: 1px;
  margin: var(--spacing-sm) var(--spacing-xs);
}

.horizontal {
  display: block;
  height: 1px;
  margin: var(--spacing-sm) 0;
}
